import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Provider } from '@angular/core';

import { AuthInterceptorService } from '../../auth/auth-interceptor.service';
import { AppHttpInterceptor } from './app-http-interceptor';
import { ClinicContextInterceptor } from './clinic-context.interceptor';

/**
 * The three interceptors that set tenant or clinic headers, in the order they must run.
 *
 * **This array is the single source of truth for that order.** `src/main.ts` spreads it and
 * `interceptor-chain.spec.ts` imports it, so the order the app ships is the order under test.
 * It used to be written out longhand in both places, which is how AB#92762 shipped: the chain
 * spec asserted its own local ordering and could not see the app's.
 *
 * Why this order (AB#92762):
 *
 * 1. `AuthInterceptorService` — appends to the caller's headers, so anything set upstream
 *    survives it.
 * 2. `ClinicContextInterceptor` — acts only on requests carrying `X-Clinic-Context`, which it
 *    consumes, replacing it with the `ClinicId` + `ClinicGroupId` of the clinic selected in the
 *    store. Must run before AppHttpInterceptor, which would otherwise destroy the marker.
 * 3. `AppHttpInterceptor` — rebuilds the header set from `localStorage` rather than cloning the
 *    caller's, so it must run last of the three. It honours an incoming `ClinicId` **and**
 *    `ClinicGroupId` so that step 2's work is carried through rather than half-overwritten.
 *
 * `MsalInterceptor` is registered after these in `main.ts` and sets no tenant headers.
 */
export const TENANT_INTERCEPTOR_PROVIDERS: Provider[] = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: ClinicContextInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: AppHttpInterceptor, multi: true },
];
